function getEnvironment() {
   return process.env.VUE_APP_ENVIRONMENT_TYPE;
}

function isProduction() {
    return process.env.VUE_APP_ENVIRONMENT_TYPE === "production";
}

function isDevelopment() {
    //return process.env.VUE_APP_ENVIRONMENT_TYPE === "development";
    // when running with npm run serve
    return true
}
function impersonationEnabled() {
    return true
}

export {
    getEnvironment,
    isProduction,
    isDevelopment,
    impersonationEnabled,
}